// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__ghOsO","description":"PatientConsentPreview_description__2dFfK"};